import { MARQUEE_ITEMS } from '../data/site';

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];

  return (
    <div className="marquee relative overflow-hidden py-5 border-y border-line" aria-hidden="true">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-void to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-void to-transparent z-10" />
      <div className="flex w-max animate-marquee motion-reduce:animate-none">
        {items.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center shrink-0">
            <span className="px-6 font-mono text-[11px] uppercase tracking-label text-faint">
              {item}
            </span>
            <span className="h-1 w-1 rounded-full bg-accent/60" />
          </span>
        ))}
      </div>
    </div>
  );
}
